import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';
import { BASE_URL } from 'app/utils/utils';
import { onQueryStartedErrorToast } from './apiErrorHandler';

export const userApi = createApi({
  reducerPath: 'user',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/user/versions/1/',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const user = (getState() as RootState).userSlice;
      if (user.auth) {
        headers.set('x-ais-user-csrf', user.auth.value.csrfToken);
        headers.set('ais-user-csrf', user.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['User'],
  endpoints: (build) => ({
    getUserData: build.query<any, any>({
      query: () => ({
        url: 'userInfo',
        withCredentials: true,
        invalidatesTags: ['User'],
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
  }),
});

export const { useLazyGetUserDataQuery } = userApi;
